import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'
import { Text } from '@wartek-id/text'

import SubjectItem from './SubjectItem'
import { useAPIGetSubjectByClassAndSchoolType } from 'api/filters/useAPIFilters'
import { getClassesByPhase } from 'app/AssessmentPage/utils/class'
import { removeDuplicate } from 'utils/array'

import type { TFase, TFaseGroup } from 'types/classAndPhases'

import ImgEmptySearch from 'assets/images/assessment/img-empty-search-result.svg'

export interface SubjectFilterResultProps {
  phase: TFase
  phaseGroup: TFaseGroup
  keyword: string
  selectedSubject?: string
  onSelectedSubjectChange?: (subject: string) => void
}

const SubjectNotFoundEmptyState = () => {
  return (
    <div className="mt-[200px] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div>
          <ImgEmptySearch alt="No subject found" height={120} width={120} />
        </div>
        <div className="flex flex-col items-center">
          <Text>Mapel tidak ditemukan</Text>
          <Text>Pastikan ejaan sudah benar.</Text>
        </div>
      </div>
    </div>
  )
}

const SubjectFilterResult = ({
  phase,
  phaseGroup,
  keyword,
  selectedSubject,
  onSelectedSubjectChange,
}: SubjectFilterResultProps) => {
  const { data, isLoading } = useAPIGetSubjectByClassAndSchoolType({
    class: getClassesByPhase(phase),
    phaseGroup,
  })
  const subject = removeDuplicate(
    (data?.data?.more_subject ?? [])
      ?.map((subj) => subj?.value)
      ?.sort((a, b) => a?.localeCompare?.(b))
  )

  const filteredSubjects = React.useMemo(() => {
    let filteredSubject =
      subject?.filter((subj) =>
        subj?.toLowerCase?.()?.includes?.(keyword?.toLowerCase?.())
      ) ?? []

    if (
      selectedSubject &&
      filteredSubject.length > 0 &&
      filteredSubject?.indexOf(selectedSubject) !== -1
    ) {
      filteredSubject?.unshift?.(
        filteredSubject?.splice?.(
          filteredSubject?.indexOf?.(selectedSubject),
          1
        )?.[0]
      )
    }
    return filteredSubject
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, subject])

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 10 })?.map((_, index) => (
          <Shimmer key={index} height={30} className="mt-4 !w-full" />
        ))}
      </>
    )
  }
  return (
    <>
      {filteredSubjects?.length > 0 ? (
        filteredSubjects?.map((subj) => (
          <SubjectItem
            key={subj}
            subject={subj}
            keyword={keyword}
            selectedSubject={selectedSubject}
            onClick={() => {
              onSelectedSubjectChange?.(subj === selectedSubject ? null : subj)
            }}
          />
        ))
      ) : (
        <SubjectNotFoundEmptyState></SubjectNotFoundEmptyState>
      )}
    </>
  )
}

export default SubjectFilterResult
